<template>
    <div
        :class="[{'has-error': !!error},formGroupClass]"
    >
        <label v-show="label" :for="name+prefix">{{ label }} <span v-show="requireField" class="red">*</span></label>
        <input v-if="type == 'text' || type == 'email' || type == 'password' || type == 'number'"
          :id="name+prefix"
          :name="name+prefix"
          :type="type"
          :value="myValue"
          :placeholder="placeholder"
          class="form-control"
          :class="inputClass"
          @input="$emit('input', $event.target.value)"
          @blur="$emit('validate',name,prefix)"
          @keyup="$emit('validate',name,prefix)"
          :disabled="disabled"
        />

        <div v-else-if="type == 'radio'" class="row"
          @input="$emit('input', $event.target.value)"
          @blur="$emit('validate',name,prefix)"
          @change="$emit('validate',name,prefix)"
        >
          <div v-for="(option, index) in optionDatas" :key="index" :class="inputClass">
            <input type="radio" class="ml-2" :name="name+prefix" :id="name+prefix+option.id" :value="option.id" v-model="myValue" :disabled="disabled"> <label :for="name+prefix+option.id">{{ option.value }}</label>
          </div>
        </div>

        <select v-else-if="type == 'select'"
          :id="name+prefix"
          :name="name+prefix"
          :value="myValue"
          :placeholder="placeholder"
          class="form-control"
          :class="inputClass"
          @input="$emit('input', $event.target.value)"
          @blur="$emit('validate',name,prefix)"
          @change="$emit('validate',name,prefix)"
          :disabled="disabled"
        >
          <option value="">--กรุณาเลือกข้อมูล--</option>
          <option v-for="(option, index) in optionDatas" :key="index" :value="option.id">{{ option.value }}</option>
        </select>

        <small class="error-message" v-show="!!error">{{ error }}</small>
    </div>
</template>

<script>
export default {
  name: "FormInput",
  props: {
    error: { required: true },
    formGroupClass: {
      type: String,
    },
    inputClass: {
      type: String,
    },
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: [String, Number, Boolean],
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
    },
    requireField: {
      type: Boolean,
      default: false,
    },
    optionDatas: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      myValue: null
    }
  },
  watch: { 
    value: function(newVal, oldVal) { // watch it
    // console.log(oldVal,newVal)
      this.myValue = newVal;
    }
  },
  created() {
    this.myValue = this.value;
  },
};
</script>